import Cookies from "js-cookie";
import {
  COOKIE_BANNER_TRIGGER,
  COOKIE_OPTIONS_LOCALSTORAGE_NAME,
} from "../constants";
import { getRootDomain } from "../utils";

const getCookieSettings = () => {
  const cookieOptions = localStorage.getItem(COOKIE_OPTIONS_LOCALSTORAGE_NAME);
  if (!cookieOptions) {
    return {};
  }

  let cookieSettings = {};
  try {
    cookieSettings = JSON.parse(cookieOptions);
  } catch (err) {
    cookieSettings = {};
  }

  const { cookieGroups } = cookieSettings;

  return cookieGroups !== undefined ? cookieGroups : {};
};

const setConsentCookie = (payload) => {
  const domainName = getRootDomain(window.location.hostname);
  if (!domainName || !window.location.hostname.includes(domainName)) {
    return;
  }

  Cookies.set("consentUpdated", JSON.stringify(payload), {
    domain: domainName,
  });
};

export const privacyWireVW = () => {
  const cookieSettings = getCookieSettings();
  if (Object.keys(cookieSettings).length && window?.dataLayer) {
    window.dataLayer.push({ event: "consentUpdated" });
    setConsentCookie(cookieSettings);
  }

  document.addEventListener("click", (e) => {
    if (window?.PrivacyWire && e.target.closest(COOKIE_BANNER_TRIGGER)) {
      e.preventDefault();
      window.PrivacyWire.showOptions();
    }
  });
};

export const privacyWireCustomHandler = () => {
  if (!window?.PrivacyWire || !window?.dataLayer) {
    return;
  }

  const cookieSettings = getCookieSettings();
  if (!Object.keys(cookieSettings)) {
    return;
  }

  window.dataLayer.push({ event: "consentUpdated" });
  setConsentCookie(cookieSettings);
};
